module.exports = __webpack_public_path__ + "img/i_c_new_05.66081edf.svg";